import {VPaidProps} from "../Advertisement/VPaid";
import {getVast} from "../Advertisement";
import React, {useEffect, useRef} from "react";




import { VideoProps, Adv } from "./Types";
import { PlayerAndDispatch } from '../PlayerReducer';
import {useRefState} from "../utils";



/**
 * Vyhledani reklamy, a priprava pro prehravac
 *
 * @param state

 */

export const useAdv = (state: PlayerAndDispatch) : [Adv, (adv:Adv)=>void ] => {


    const hasAdv = state.adv && state.station && state.station.reklama ? state.station.reklama.url : false ;
    const [adv, setAdv, getAdv] = useRefState<Adv>(!hasAdv ? false : undefined);

    useEffect(()=>
    {

        if (hasAdv) {

            getVast(hasAdv).then((vast) => {

                if (!vast) {
                    setAdv(false);
                    return;
                }

                let videosources: {
                    type: string
                    src: string,
                    width: number,
                    height: number,
                    vzdalenost: number,
                    name: string
                }[] = [];

                let jssource = '';
                let isJs = false;
                if (!state.element) {
                    setAdv(false);
                    return;
                }

                const width = state.element.offsetWidth;
                const height =state.element.offsetHeight;
                console.log(state.element.offsetWidth, state.element.offsetHeight);

                const current = Math.sqrt(width*width + height*height);

                vast.sources.forEach((item) => {
                    if (item.type === 'application/javascript') {
                        jssource = item.src;
                        isJs = true;
                        return true;
                    } else {
                        videosources.push({
                            ...item,
                            name: item.width + "x" + item.height,
                            vzdalenost: Math.abs(Math.sqrt(item.width * item.width + item.height + item.height) - current)
                        })
                    }
                    return false;
                });

                if (isJs) {

                    const vpaidProps: VPaidProps = {
                        type: 'VPAIDPROPS',
                        width,
                        height,
                        volume: 0,
                        scriptUrl: jssource,
                        adStart: () => {

                        },
                        complete: () => {

                        },
                        vastData: vast
                    }
                    setAdv(vpaidProps);
                } else {
                    vast.vastTracker.on('clickthrough', url => {
                        window.open(url, '_blank');
                    });

                    let name = '';

                    videosources = videosources.sort((a, b) => {
                        return a.vzdalenost - b.vzdalenost
                    }).filter((a) => {
                        if (!name || name === a.name) {
                            name = a.name;
                            return true;
                        }
                        return false;
                    })
                    const wh = videosources[0].width / videosources[0].height;
                    const videoProps: VideoProps = {
                        type: "VIDEOPROPS",
                        sources: videosources,
                        width: videosources[0].width,
                        height: videosources[0].height,
                        vastData: vast,
                        style: {
                            width: (wh > 1 ? width :  (height * wh) ) + 'px' ,
                            height: (wh < 1 ? height : width * (1/wh) ) + 'px'
                        }
                    }
                    console.log(videoProps);
                    setAdv(videoProps);
                }

            }).catch(() => {
                setAdv(false);
            })

        }
    }, [hasAdv]);


    return [adv, setAdv];
}

